import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type QuizContentTypeSearchFragment = { id: string, name: string, type: Types.ResourceTypeEnum, quizQuestionsConfig: { questionCount: number } };


export type QuizContentTypeSearchFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const QuizContentTypeSearchFragmentDoc = /*#__PURE__*/ gql`
    fragment QuizContentTypeSearch on QuizContentType {
  id
  name
  type
  quizQuestionsConfig {
    questionCount
  }
}
    `;